module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Regular-Hestia.476563b.woff";